import { render, staticRenderFns } from "./ErrorPage404.vue?vue&type=template&id=989119d8&scoped=true&"
import script from "./ErrorPage404.vue?vue&type=script&lang=js&"
export * from "./ErrorPage404.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPage404.vue?vue&type=style&index=0&id=989119d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989119d8",
  null
  
)

export default component.exports